/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import { getInfoWindow } from './CustomInfoWindow';
import { getInner } from './swInfoWindow';

export default class FairInfoWindow extends React.Component {
  render() {
    const imageLink = this.props.ImageFile ? this.props.ImageFile : this.props.ImageLink;
    const linkTarget = this.props.Path;
    const inner = getInner(this.props.Name, this.props.onMouseLeave, imageLink, this.props.children, linkTarget);
    return getInfoWindow(this.props, inner);
  }
}
